import { CLOUD_API_URL } from '../config/serverConfig';

const INITIAL_IMPORT_FLAG = 'maestro_qobuz_playlists_imported_v4';

export function getAuthToken(): string | null {
  try {
    const stored = localStorage.getItem('maestro_auth');
    return stored ? JSON.parse(stored).accessToken : null;
  } catch {
    return null;
  }
}

export function authedFetch(path: string, method: string, body?: unknown): Promise<Response> {
  const token = getAuthToken();
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  const init: RequestInit = { method, headers };
  if (body !== undefined) init.body = JSON.stringify(body);
  return fetch(`${CLOUD_API_URL}${path}`, init);
}

export function hasCompletedInitialQobuzImport(): boolean {
  try {
    return localStorage.getItem(INITIAL_IMPORT_FLAG) === '1';
  } catch {
    return false;
  }
}

export function markInitialQobuzImportDone(): void {
  try {
    localStorage.setItem(INITIAL_IMPORT_FLAG, '1');
  } catch {}
}

export function clearQobuzImportFlag(): void {
  try {
    localStorage.removeItem(INITIAL_IMPORT_FLAG);
  } catch {}
}
